const mainWebsiteUrl = 'https://widgetbrain.com/';

export default {
  systemStatusUrl: mainWebsiteUrl + 'status',
  faqUrl: mainWebsiteUrl + 'support',
  widgetBrainSupportEmail: 'support@widgetbrain.com',
  auth0Config: {
    "domain": "widgetbrain.eu.auth0.com",
    "clientID": "DcoDtviEjVrrIWYYOy7pET97xWVGY4xx",
  }
}


// WEBPACK FOOTER //
// ./src/helpers/config.js